const ROWS = [
  { colour: "Green report", dot: "#16a34a", meaning: "You were not at fault — a liable party is identified", excess: "No excess for covered damage" },
  { colour: "Red report", dot: "#dc2626", meaning: "You were at fault", excess: "Excess applies (AED 1,500 std / 2,500 premium) — AED 0 with SCDW" },
  { colour: "White report", dot: "#d1d5db", meaning: "Unknown damage — no liable party identified", excess: "Excess applies — AED 0 with SCDW" },
  { colour: "Reference number only", dot: "#f59e0b", meaning: "Not a final report — a security block equal to the excess is held until the final report is validated", excess: "Block released once validated" },
  { colour: "No final report", dot: "#111827", meaning: "Standard insurance and SCDW do not apply", excess: "Repair, recovery & restoration costs chargeable to the renter" },
];

export const ReportColourMatrix = () => (
  <div className="bg-white rounded-lg border border-[#e2ebe4] overflow-hidden" data-testid="report-colour-matrix">
    <div className="bg-[#144733] text-white px-4 py-3 heading-upper text-sm tracking-widest">Police report colours — what they mean</div>
    <div className="divide-y divide-[#f1f3f1]">
      {ROWS.map((r) => (
        <div key={r.colour} className="p-3 grid sm:grid-cols-[170px_1fr_1fr] gap-1 sm:gap-3 text-xs items-start">
          <span className="flex items-center gap-2 font-semibold text-[#0F1E17]">
            <span className="w-3 h-3 rounded-full border border-[#d5ddd5] shrink-0" style={{ background: r.dot }} /> {r.colour}
          </span>
          <span className="text-[#57685e]">{r.meaning}</span>
          <span className="text-[#144733] font-medium">{r.excess}</span>
        </div>
      ))}
    </div>
    <p className="px-4 py-3 text-[11px] text-[#8a978f] bg-[#fafcfa]">Authority report fees are borne by the renter where charged. Final reports may be issued by police or an authorised entity such as Rafid or Saaed.</p>
  </div>
);
